<script setup>
import { ref } from 'vue';

import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import CompanyCreateDialog from 'dashboard/components-next/Companies/CompanyCreateDialog.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import CompaniesCard from 'dashboard/components-next/Companies/CompaniesCard/CompaniesCard.vue';
import companyContent from 'dashboard/components-next/Companies/EmptyState/companyEmptyStateContent';

defineProps({
  title: {
    type: String,
    default: '',
  },
  subtitle: {
    type: String,
    default: '',
  },
  showButton: {
    type: Boolean,
    default: true,
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['create']);

const createCompanyDialogRef = ref(null);

const onClick = () => {
  createCompanyDialogRef.value?.dialogRef.open();
};
</script>

<template>
  <EmptyStateLayout :title="title" :subtitle="subtitle">
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <CompaniesCard
          v-for="company in companyContent.slice(0, 5)"
          :id="company.id"
          :key="company.id"
          :name="company.name"
          :domain="company.domain"
          :description="company.description"
          :city="company.city"
          :country-code="company.countryCode"
          :contacts-count="company.contactsCount"
          :first-contacts="company.firstContacts"
          :avatar-url="company.avatarUrl"
          :social-profiles="company.socialProfiles"
          :is-expanded="false"
        />
      </div>
    </template>
    <template #actions>
      <div v-if="showButton">
        <Button :label="buttonLabel" icon="i-lucide-plus" @click="onClick" />
        <CompanyCreateDialog
          ref="createCompanyDialogRef"
          @create="emit('create', $event)"
        />
      </div>
    </template>
  </EmptyStateLayout>
</template>
